import { useNavigate } from 'react-router-dom';

import Tools from '../../../../tools/tools.js';

import {
    TableData,
    TableRow
} from '../../../../styles/component.styles.jsx';

const tools = new Tools();

const OrderItem = ({ item }) => {
    const navigate = useNavigate();
    const inventory = item.Inventory;
    const product = item.Product;

    if (!inventory || !product) {
        return (
            <TableRow>
                <TableData colSpan={4}>
                    Missing inventory or product data
                </TableData>
            </TableRow>
        );
    }

    return (
        <TableRow>
            <TableData onClick={() => navigate(`/products/${product.id}`)}>{product.name}</TableData>
            <TableData>{inventory.size}</TableData>
            <TableData>{item.quantity}</TableData>
            <TableData>{tools.formatPrice(item.totalPrice)}</TableData>
        </TableRow>
    );
};

export default OrderItem;